import React from "react";
import { useLocation } from "react-router-dom";
import Page from "@druva-apps/orion/lib/page";
import Container from "@druva-apps/orion/lib/container";
import Row from "@druva-apps/orion/lib/row";
import Col from "@druva-apps/orion/lib/col";

import ImgLogo from "../../assets/images/druva-logo-new.svg";

import styles from "./Auth.module.scss";
import FormContainer from "./components/FormContainer";
import AuthFooter from "./AuthFooter";
import PageFooter from "./PageFooter";
import resolveAuthVersion from "utils/resolveAuthVersion";

const Auth = () => {
  const location = useLocation();
  const version = resolveAuthVersion(location.pathname);

  return (
    <Page honourNavHeight={false} className={styles.page}>
      <Page.Main>
        <Page.Body>
          <Container className="d-flex flex-column h-100 justify-content-center align-items-center">
            <Row>
              <Col>
                <div className={`${styles.card} oui-card`}>
                  <div className="oui-my-4 oui-mx-auto">
                    <img
                      src={ImgLogo}
                      alt="Druva Logo"
                      className="oui-mt-2"
                      data-testid="login-mfa-logo"
                    />
                  </div>
                  <div className={styles.cardForm}>
                    <FormContainer version={version} />
                  </div>
                </div>
              </Col>
            </Row>
            <AuthFooter />
          </Container>
          <PageFooter />
        </Page.Body>
      </Page.Main>
    </Page>
  );
};

export default Auth;
